module.exports = __webpack_public_path__ + "static/fiPines.63483adc.jpg";